import { OcaTemplate, ReferenceType } from '@trnsact/trnsact-shared-types';
import { checkIfDocumentSignSection, checkIfPersonalGuaranteeSignaturesSection } from 'services/dynamicOCAService';

const findSection = (ocaTemplate: OcaTemplate, predicate: (section: any) => boolean) =>
  ocaTemplate?.jsonDefinition.flatMap((page: any) => page.sections).find(predicate);

export const getSectionByReferenceType = (ocaTemplate: OcaTemplate, referenceType: ReferenceType) =>
  findSection(ocaTemplate, section => section.referenceType === referenceType);

export const getDocumentSignSection = (ocaTemplate: OcaTemplate) =>
  findSection(ocaTemplate, checkIfDocumentSignSection);

export const getPersonalGuaranteeSignaturesSection = (ocaTemplate: OcaTemplate) =>
  findSection(ocaTemplate, checkIfPersonalGuaranteeSignaturesSection);

export const getSectionByFieldName = (ocaTemplate: OcaTemplate, fieldName: string) =>
  findSection(ocaTemplate, section => section.fields?.find((field: any) => field.config.fieldName === fieldName));
